import React from "react";
import { TextField } from "@rmwc/textfield";
import { ShowBuildingImage } from "../../../Intel/defaultBuilding/defaultbuilding.helper.js";

const BuildingInfo = ({ params, const_var, imageName, changeOtherBuildingTypeName, handleAccordionTab }) => {
	return const_var.loginSession == true ? (
		<div className="form-group">
			<label className="control-label">{const_var.crmSetting.is_module_name == "inventory" ? "Inventory Name" : "Building Name"}</label>

			<div className="floating-label-input">
				<TextField name="other_building_type_name" maxLength={50} value={params.other_building_type_name} onChange={(e) => changeOtherBuildingTypeName(e.target.value, "other")} />
			</div>
		</div>
	) : (
		<div className="media-size-box">
			<div className="media-size">
				<ShowBuildingImage src={imageName} />

				<div className="media-body">
					<strong className="media-title">{params.building_type_name}</strong>

					<ul className="dimension">
						<li className="item-dimension">
							<span className="dimension-label">W</span>
							<span className="dimension-value">{params.p_w}'</span>
						</li>

						<li className="item-dimension">
							<span className="dimension-label">L</span>
							<span className="dimension-value">{params.p_d}'</span>
						</li>

						<li className="item-dimension">
							<span className="dimension-label">H</span>
							<span className="dimension-value">{params.p_h}'</span>
						</li>
					</ul>

					{!const_var?.is_intel && (
						<a className="media-action" onClick={(e) => handleAccordionTab(e, "buildingtypetab", "change")}>
							<span className="text">Change Building</span>

							<span className="icon">
								<i className="icon-edit-ico"></i>
							</span>
						</a>
					)}
				</div>
			</div>
		</div>
	);
};

export default BuildingInfo;
